const callbacks: (() => void)[] = [];

let isReady = ['interactive', 'complete'].includes(document.readyState);

document.addEventListener('DOMContentLoaded', () => {
    isReady = true;
    callbacks.forEach(cb => cb());
});

export function domReady(cb: () => void) {
    if (isReady) {
        cb();
        return;
    }

    callbacks.push(cb);
}
